import { ReactElement } from 'react';
import DownloadButton from '../../../../../../common/download-button/download-button';
import { BUTTON_TYPES } from '../../../../../../constants/button-variants';
import { FavoritesMaterialCardProps } from '../../types';
import AddToFolderIconButton from '../add-to-folder-icon-button/add-to-folder-icon-button';
import MaterialRemoveButton from '../material-remove-button/material-remove-button';

type MaterialAcquiredInfoProps = {
    item: FavoritesMaterialCardProps['item'];
    index: FavoritesMaterialCardProps['index'];
    downloadButtonType: BUTTON_TYPES;
    shouldShowFolder?: boolean;
    removeButtonType?: 'icon' | 'removeOnly';
};

const MaterialAcquiredInfo = (props: MaterialAcquiredInfoProps): ReactElement => {
    const { item, downloadButtonType, shouldShowFolder, index, removeButtonType } = props;

    const downloadStatus = item.isFree ? 'free' : '';
    const downloadButtonProps = { materialId: item.id, aclId: item.aclId, downloadStatus, type: downloadButtonType };

    return (
        <>
            <div className='button-wrapper download-button-wrapper'>
                <DownloadButton id='download-button-aclId-material' {...downloadButtonProps} />
            </div>

            {shouldShowFolder && <AddToFolderIconButton item={item} />}

            {removeButtonType && <MaterialRemoveButton item={item} index={index} type={removeButtonType} />}
        </>
    );
};

export default MaterialAcquiredInfo;
